import { createContext, useContext, useState } from 'react'

const ThemeContext = createContext()

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider')
  }
  return context
}

export const ThemeProvider = ({ children }) => {
  const [user, setUser] = useState(null) // Placeholder for authentication

  // Placeholder auth functions
  const signIn = (email, password) => {
    // Mock sign in
    setUser({ email, name: 'Demo User', id: '1' })
    return Promise.resolve({ success: true })
  }

  const signOut = () => {
    setUser(null)
    return Promise.resolve()
  }

  const value = {
    user,
    signIn,
    signOut,
    isAuthenticated: !!user,
  }

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}
